module.exports = __webpack_public_path__ + "img/big_tick.e2207506.svg";